import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Sparkles, CheckCircle2 } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    number: '1',
    title: 'WhatsApp',
    description: 'Fotos, audios y mensajes.',
    icon: <MessageCircle className="w-7 h-7 text-blue-600" data-id="element-131" />
  }, {
    number: '2',
    title: 'Obra Digital',
    description: 'Ordena y resume automáticamente.',
    icon: <Sparkles className="w-7 h-7 text-blue-600" data-id="element-132" />
  }, {
    number: '3',
    title: 'Resultado',
    description: 'Historial, búsqueda e informes.',
    icon: <CheckCircle2 className="w-7 h-7 text-blue-600" data-id="element-133" />
  }];
  return <section id="como-funciona" className="scroll-mt-20 py-16 sm:py-24 bg-white" data-id="element-134">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <div className="text-center mb-12 sm:mb-16" data-id="element-136">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-gray-900 tracking-tight" data-id="element-137">
            Así funciona
          </h2>
        </div>

        {/* Steps */}
        <div className="relative" data-id="element-138">
          <div className="hidden md:block absolute top-9 left-[16%] right-[16%] h-0.5 bg-gray-200 z-0" data-id="element-139" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 sm:gap-12 relative z-10" data-id="element-140">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="flex flex-col items-center text-center" data-id="element-141">
                <div className="relative mb-5" data-id="element-142">
                  <div className="w-[72px] h-[72px] bg-white rounded-2xl border-2 border-gray-100 shadow-sm flex items-center justify-center" data-id="element-143">
                    {step.icon}
                  </div>
                  <div className="absolute -top-2.5 -right-2.5 w-7 h-7 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-xs border-2 border-white shadow-sm" data-id="element-144">
                    {step.number}
                  </div>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 leading-snug" data-id="element-145">
                  {step.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 max-w-[260px] leading-relaxed" data-id="element-146">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}